import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './config/redux'
import AppRouter from './AppRouter'

const EnhancedApp = () => (
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <AppRouter />
        </PersistGate>
    </Provider>
)

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<EnhancedApp />)
